export default __webpack_public_path__ + "static/media/folder-icon.659c1307.svg";